/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'sys-log': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.333 16H2.667A2.67 2.67 0 010 13.333V4a2.67 2.67 0 012.667-2.667H4A2.67 2.67 0 006.667 4h2.666A2.67 2.67 0 0012 1.333h1.334A2.67 2.67 0 0116 4v9.334A2.67 2.67 0 0113.333 16zM11.1 13.11l1.389 1.39a.99.99 0 001.407 0 1 1 0 000-1.41L12.5 11.7a2.325 2.325 0 00-3.1-2.914l-.138.061a.116.116 0 00-.07.086.119.119 0 00.033.106l1.3 1.3-.782.781-1.275-1.269H8.46a.139.139 0 00-.1-.039.141.141 0 00-.03 0 .136.136 0 00-.1.086L8.19 10a2.324 2.324 0 002.91 3.111zM3 8a.5.5 0 000 1h3a.5.5 0 000-1zm0-2a.5.5 0 000 1h3a.5.5 0 000-1zm6.333-3.333H6.667a1.333 1.333 0 110-2.667h2.666a1.333 1.333 0 010 2.667z" _fill="#212121"/>'
  }
})
